import { Component, Mixins } from 'vue-property-decorator'
import { mapGetters, mapState } from 'vuex'
import { DateMixin, NumberMixin } from '@kwixeo/interface-vue'
import { BRow, BCol, BButton } from 'bootstrap-vue'

@Component({
  components: {
    BRow, BCol, BButton
  },
  computed: {
    ...mapState('app', ['app']),
    ...mapGetters('user', ['team'])
  }
})
export default class CommandMixin extends Mixins(NumberMixin, DateMixin) {
  app!: KwixeoFramework.App
  team!: KwixeoFramework.Team
}
